export const SET_LOADING='app/setloading'
export const SET_PRELOADING='app/setpreloading'
export const GET_USER_MENU_END='GET_USER_MENU_END'
export const HANDLE_ERROR='HANDLE_ERROR'
export const SET_MESSAGE='SET_MESSAGE'
export const CLOSE_MESSAGE='CLOSE_MESSAGE'
export const SET_TOP_MESSAGE='SET_TOP_MESSAGE'
export const REMOVE_TOP_MESSAGE='REMOVE_TOP_MESSAGE'